export interface IMetricsOverview {
  newUsers?: number;
  newBusinesses?: number;
  newSubscriptions?: number;
  bookings?: number;
  completedBookings?: number;
}

export const defaultValue: Readonly<IMetricsOverview> = {
  newUsers: 0,
  newBusinesses: 0,
  newSubscriptions: 0,
  bookings: 0,
  completedBookings: 0,
};

export interface ITimeseriesPoint {
  date: string;
  newUsers: number;
  newBusinesses: number;
  newSubscriptions: number;
  bookings: number;
}
